import React from "react";

import { NavigationContainer } from "@react-navigation/native";
import BoardingStack from "./BoardingStack";
import { useAppSelector } from "../hooks/reduxHooks";
import HomeStack from "./HomeStack";

const RootStack = () => {
	const isLoggedIn = useAppSelector(s => s.auth.auth && s.auth.subUser);

	return (
		<NavigationContainer>
			{isLoggedIn ? <HomeStack /> : <BoardingStack />}
		</NavigationContainer>
	);
};

export default RootStack;
